import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { callGTMAnalytics } from '../../helper/analyticsTag';
import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';

type Props = {
  gridApi: any;
  searchText: string;
};

const ExportToExcel: React.FC<Props> = ({ gridApi, searchText }) => {
  const [utagData] = useRecoilState(utagObjectAtom);
  const { t } = useTranslation();

  const exportTableToExcelHandler = () => {
    // Check if Grid ready
    if (gridApi && !gridApi.destroyCalled) {
      const searchValue = encodeURIComponent(searchText.toUpperCase()).replace(
        '.',
        '_'
      );

      gridApi.exportDataAsExcel({
        columnKeys: [
          'manufacturerProductNumber',
          'catalogDescription',
          'supplier',
          'crossType.crossName',
          'digikeyPartNumber'
        ],
        fileName: `${t('xref-crosses')}_${searchValue}`,
        sheetName: `${t('xref-crosses')}_${searchValue}`,
        columnWidth: 210
      });
    }
  };

  return (
    <button
      className="dk-btn__secondary"
      id="btn-download-table"
      onClick={() => {
        exportTableToExcelHandler();
        return callGTMAnalytics(utagData, 'Download Table');
      }}
      data-testid="export-to-excel"
      track-data="ref_page_event=Download Table"
    >
      {t('xref-download-table')}
    </button>
  );
};

export default ExportToExcel;
